import { render, staticRenderFns } from "./SelectedDepartment.vue?vue&type=template&id=3e396ee4&scoped=true"
import script from "./SelectedDepartment.vue?vue&type=script&lang=js"
export * from "./SelectedDepartment.vue?vue&type=script&lang=js"
import style0 from "./SelectedDepartment.vue?vue&type=style&index=0&id=3e396ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e396ee4",
  null
  
)

export default component.exports